import React from "react";
import { Drawer, Box, IconButton ,Typography} from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import PaidIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import down from "../../../../assets/down.svg";
import view from "../../../../assets/Wallet/view.png";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import StatusDropdown from "../../../../components/StatusDropdown";
import receipt from "../../../../assets/Wallet/receipt.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import document1 from "../../../../assets/document1.svg";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";


const DetailsDrawer = ({ open, onClose, data }) => {
  const { t } = useTranslation();
    const [editOpen, setEditOpen] = React.useState(false);

  console.log(data);
    const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const localDate = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return localDate === "—" ? "-" : localDate;
};
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 550,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
{t("salaryManagement.request")}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {/* Status & Date */}
        <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.status")}
            </CustomText>

              <Box sx={{ pointerEvents: "none" }}>
                    
                    <StatusDropdown currentStatus={data?.status} />
                    </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.date")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                              {formatDateTime(data?.created_at)}
            </CustomText>{" "}
          </Box>

              <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {t("salaryManagement.comments")}
            </CustomText>

            <Box
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
{data?.decision_note || "-"}            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#000000",
              textAlign: "left",
            }}
          >
{t("salaryManagement.requestDetails")}
        </CustomText>
          {/* <img src={down} width={40} height={30} /> */}
          
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.workerName")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
{data?.worker?.name}            </CustomText>{" "}
          </Box>



          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
{t("salaryManagement.amount")}          </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                    {data?.amount} {data?.currency}
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
{t("salaryManagement.dateOfExpense")}
           </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                              {formatDateTime(data?.date_of_expense)}
            </CustomText>{" "}
          </Box>


          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.description")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
              {data?.description}
            </CustomText>{" "}
          </Box>
        </Box>

        {/* Recipe Box (Optional) */}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
          sx={{ mt: 2 }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 600,
                color: "#000000",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.receipt")}
            </CustomText>
            {/* <img src={down} width={40} height={30} /> */}
          </Box>

          <Box>
            <img src={receipt} style={{ width: 30, height: 30 }} />
          </Box>
        </Box>

 {/* <Box
  sx={{
    p: 2,
    overflowY: "auto",
    flexGrow: 1,
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    mt: 2,
    display: "flex",
    justifyContent: "center", // center horizontally
    alignItems: "center"       // center vertically
  }}
>
  <img
    crossOrigin="anonymous"
    src={data?.receipt_url}
    style={{
      maxWidth: "100%",   // don’t overflow box width
      maxHeight: "250px", // control height
      objectFit: "contain",
      borderRadius: "8px"
    }}
    alt="Proof"
  />
</Box> */}

<Box
  sx={{
    p: 2,
    overflowY: "auto",
    flexGrow: 1,
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    mt: 2,
    width: "100%",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
  }}
>
  {(() => {
    const fileUrl = data?.receipt_url;
    if (!fileUrl) return <CustomText>No file uploaded</CustomText>;

    const isPdf = fileUrl.toLowerCase().endsWith(".pdf");
    const fileName = fileUrl.split("/").pop();

    return (
      <>
        {/* Preview */}
        <Box
          sx={{
            width: "100%",
            height: 200,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#F8F9FA",
            border: "1px solid #E4E6EF"
          }}
        >
          {isPdf ? (
            <>
            <Box sx={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
            <img
              src={document1}
              alt="PDF Preview"
              style={{ width: 40, height: 40 }}
            />
              <Typography
          sx={{
            fontSize: 14,
            mt: 1,
            maxWidth: "100%",
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontFamily: "Poppins"
          }}
          title={fileName}
        >
          {fileName}
        </Typography>
        </Box>
        </>
          ) : (
            <img
              crossOrigin="anonymous"
              src={fileUrl}
              alt="Receipt"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                borderRadius: 8
              }}
            />
          )}
        </Box>

        {/* File name */}
{isPdf && (
  <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
    <CustomButton
      onClick={() => window.open(fileUrl, "_blank")}
      size="small"
      label={t("viewDocument")}
    />
  </Box>
)}
      </>
    );
  })()}
</Box>

        {/* Payment Information Section (only show when status is "paid") */}
        {data?.status === "paid" && (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 3 }}>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#000000",
                  textAlign: "left",
                }}
              >
                {t("salaryManagement.paymentInformation") || "Payment Information"}
              </CustomText>
            </Box>

            <Box
              sx={{
                border: "1px solid #E4E6EF",
                borderRadius: 2,
                px: 2,
                py: 2,
                mt: 2,
              }}
            >
              {data?.paid_at && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("salaryManagement.paymentDate") || "Payment Date"}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {formatDateTime(data.paid_at)}
                  </CustomText>
                </Box>
              )}

              {data?.paid_by_name && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("salaryManagement.paidBy") || "Paid By"}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {data.paid_by_name}
                  </CustomText>
                </Box>
              )}

              {data?.payment_method && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("salaryManagement.paymentMethod") || "Payment Method"}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                      textTransform: "capitalize",
                    }}
                  >
                    {data.payment_method === "bank"
                      ? "Bank Transfer"
                      : data.payment_method === "transfer"
                      ? "Wire Transfer"
                      : data.payment_method === "cash"
                      ? "Cash"
                      : data.payment_method === "other"
                      ? "Other"
                      : data.payment_method}
                  </CustomText>
                </Box>
              )}

              {data?.paid_comment && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("salaryManagement.paymentComment") || "Payment Comment"}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      maxWidth: "60%",
                    }}
                  >
                    {data.paid_comment}
                  </CustomText>
                </Box>
              )}

              {data?.paid_proof_url && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("salaryManagement.paymentProof") || "Payment Proof"}
                  </CustomText>
                  <CustomButton
                    onClick={() => window.open(data.paid_proof_url, "_blank")}
                    size="small"
                    label={t("viewDocument") || "View Proof"}
                  />
                </Box>
              )}
            </Box>
          </>
        )}

     
      </Box>
     
    </Drawer>
  );
};

export default DetailsDrawer;